import { CurrencyPipe } from "@angular/common";
import { ChangeDetectionStrategy, Component, computed, inject, input } from "@angular/core";
import { toSignal } from "@angular/core/rxjs-interop";
import { DspAdvertiserDeal } from "@front/m19-api-client";
import { AuthService, formatDurationRanges } from "@front/m19-services";
import { TranslocoDirective } from "@jsverse/transloco";

@Component({
  selector: "app-dsp-deal-option",
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CurrencyPipe, TranslocoDirective],
  template: `
    <div class="flex w-full min-w-0 flex-col whitespace-normal" *transloco="let t">
      <div class="flex w-full items-start justify-between gap-3">
        <span class="type-body-medium text-foreground min-w-0 text-left wrap-anywhere">{{ deal().dealName }}</span>
        @if (deal().price) {
          <span class="type-label text-foreground shrink-0">
            {{
              t("dsp-media-selector.cpm", {
                cpm: deal().price | currency: deal().currency : "symbol-narrow" : "1.2-2" : locale(),
              })
            }}
          </span>
        }
      </div>
      <span class="type-caption text-muted-foreground text-left">
        {{ t("dsp-media-selector.source_" + deal().source) }}
        @if (deal().vertical) {
          · {{ deal().vertical }}
        }
        @if (durationsLabel()) {
          · {{ durationsLabel() }} s
        }
      </span>
    </div>
  `,
})
export class DspDealOptionComponent {
  private readonly authService = inject(AuthService);

  readonly deal = input.required<DspAdvertiserDeal>();
  readonly locale = toSignal(this.authService.userLocale$, { initialValue: "en-US" });
  readonly durationsLabel = computed(() => formatDurationRanges(this.deal().videoDurationRanges));
}
